// import
import Component from 'minsky-kit/js/components/Component';

// private statics

// class definition
export default class SectionTracker extends Component {
    // constructor
    constructor (args = {}, objectName = 'Navigation') {
        // debug toggle
        args.debug = args.debug || true;

        // super constructor
        super(args, objectName);

        // add listeners
        this._currentSection = null;
        this.sections = Array.from(args.sections);

        // refresh a first time
        this.refresh();

        window.st = this;
    }

    // methods
    refresh () {
        // calculate which has most area visible
        let biggestArea = 0;
        let currentSection = null;

        this.sections.forEach((section) => {
        // const section = this.sections[1];

            // skip entirely if area is infinity => means section covering whole viewport is found
            if (biggestArea === Infinity) return;

            // push rect values into an object because they are read only
            const rect = section.getBoundingClientRect();

            // if both sides are outside the viewport (= covers whole viewport) => set area to infinity and choose current section
            if ((rect.top <= 0 && rect.bottom >= window.innerHeight) && (rect.left <= 0 && rect.right >= window.innerWidth)) {
                biggestArea = Infinity;
                currentSection = section;
            }
            else {
                const bb = {};

                // < 0 => 0
                bb.top =    rect.top > 0 ? rect.top : 0;
                bb.right =  rect.right > 0 ? rect.right : 0;
                bb.bottom = rect.bottom > 0 ? rect.bottom : 0;
                bb.left =   rect.left > 0 ? rect.left : 0;

                // > viewport => max viewport
                bb.top =    bb.top < window.innerHeight ? bb.top : window.innerHeight;
                bb.right =  bb.right < window.innerWidth ? bb.right : window.innerWidth;
                bb.bottom = bb.bottom < window.innerHeight ? bb.bottom : window.innerHeight;
                bb.left =   bb.left < window.innerWidth ? bb.left : window.innerWidth;

                // calculate area
                const area = Math.abs(bb.right - bb.left) * Math.abs(bb.bottom - bb.top);

                // console.log(area);

                if (area > biggestArea) {
                    biggestArea = area;
                    currentSection = section;
                }
            }
        });

        if (window.scrollY >= (document.body.offsetHeight - window.innerHeight)) {
            currentSection = this.sections[this.sections.length - 1];
        }

        // set current section
        if (currentSection !== null) this.currentSection = currentSection;
    }

    destroy () {
        super.destroy();
    }

    // getters & setters
    get currentSection () {
        return this._currentSection;
    }

    set currentSection (section) {
        if (this._currentSection !== section) {
            this._currentSection = section;
            this.dispatch('change', {
                section,
            });
        }
    }
}

// event handlers
